import { ITranslatableItem } from "@ryde/shared";

export const normalizeWarningsValue = (
  raw: unknown,
): (ITranslatableItem | string)[] => {
  if (raw === undefined || raw === null || raw === "") {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw as (ITranslatableItem | string)[];
  }
  if (typeof raw === "string") {
    return [raw];
  }
  return [];
};
